export class AuthMethodConfigApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAuthMethodConfig({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}/auth-method-config`);
  }

  async updateAuthMethodConfig({ companyId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/auth-method-config`, body);
  }
}
